import { render, staticRenderFns } from "./UserPlaces.vue?vue&type=template&id=0c437bb8&scoped=true"
import script from "./UserPlaces.vue?vue&type=script&lang=js"
export * from "./UserPlaces.vue?vue&type=script&lang=js"
import style0 from "./UserPlaces.vue?vue&type=style&index=0&id=0c437bb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c437bb8",
  null
  
)

export default component.exports